// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__fme6s","clickable":"Icon_clickable__-Bi02","container":"Icon_container__BUMrB","overlay":"Icon_overlay__VeIpn"};